import LiveScraper from '@/components/LiveScraper';
import Seo from '@/components/Seo';

export default function ComparePage() {
  return (
    <div className="container py-6 pb-24 md:pb-8">
      <Seo
        title="Compare grocery prices live across stores | Grozo"
        description="Search any grocery item and instantly compare live prices across Zepto, Blinkit, BigBasket, Instamart, Flipkart Minutes and JioMart."
        path="/compare"
      />
      <LiveScraper />
    </div>
  );
}
